export default {
    pricePerPlayer: 20,
};
